// extracted by mini-css-extract-plugin
module.exports = {"modal_wrap":"webhooksettings_modal_wrap__2CgMq","webhook":"webhooksettings_webhook__296In","event_type":"webhooksettings_event_type__V9oWf"};